import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, RotateCcw, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

const VIEW = {
  checking: [Loader2, "Vérification du paiement…", "Merci de patienter quelques secondes.", "animate-spin text-muted-foreground"],
  completed: [CheckCircle2, "Lead acheté !", "Les coordonnées du client sont disponibles dans « Mes leads ».", "text-success"],
  refunded: [RotateCcw, "Lead déjà pris", "Un autre partenaire a été plus rapide : votre paiement est remboursé automatiquement.", "text-gold"],
  failed: [XCircle, "Paiement non abouti", "Aucun montant n'a été débité.", "text-destructive"],
};

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState(sid ? "checking" : "failed");
  useEffect(() => {
    if (!sid) { return undefined; }
    let n = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.status === "completed") return setState("completed");
        if (data.status === "refunded") return setState("refunded");
        if (["expired", "failed"].includes(data.status)) return setState("failed");
      } catch { return setState("failed"); }
      if (++n < 15) timer = setTimeout(poll, 2000); else setState("failed");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid]);
  const [Icon, title, text, cls] = VIEW[state];
  return (
    <div className="mx-auto max-w-md py-12" data-testid="payment-result">
      <div className="card-surface p-8 text-center">
        <Icon className={`mx-auto h-12 w-12 ${cls}`} />
        <h1 className="mt-4 text-2xl font-extrabold" data-testid="payment-result-title">{title}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{text}</p>
        {state !== "checking" && <Button asChild className="mt-6 rounded-full"><Link to={state === "completed" ? "/partenaires/achetes" : "/partenaires"} data-testid="payment-result-continue">Continuer</Link></Button>}
      </div>
    </div>
  );
}
